import React, { useRef, useState } from 'react'

import { useHistory, useParams } from 'react-router-dom'
import { Box, Button, Typography } from '@material-ui/core'

import { BaseDialog, Container, LoadingFeedback, Page } from 'components'

import { ChangesManagementForm } from './components'

import { routes } from 'Routes'
import * as service from 'service'

import useFetch from 'hooks/useFetch'

const ChangesManagementEdit = () => {
  const [openFinalizeDialog, setOpenFinalizeDialog] = useState(false)
  const finalizeMode = useRef(false)

  const params = useParams()
  const history = useHistory()

  const changesManagementId = params.changesManagementId

  const {
    response,
    isLoading: isLoadingChangesManagement,
    refresh,
  } = useFetch(service.dponet.changesManagement.get, { changesManagementId })

  const changesManagement = response?.data?.changesManagement
  const isFinalized = changesManagement?.status === 'finalized'

  const handleFinalize = () => {
    finalizeMode.current = true
    setOpenFinalizeDialog(false)
    document
      .getElementById('changes-management-form')
      .dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
  }

  return (
    <Page title="Editar Gestão de Mudanças">
      <LoadingFeedback open={isLoadingChangesManagement} />
      <Container maxWidth={false}>
        <ChangesManagementForm
          changesManagement={changesManagement}
          finalizeMode={finalizeMode}
          refresh={refresh}
          isEdit
          isShow={isFinalized}
        />
        <Box ml={2} mt={2} display="flex" justifyContent="flex-end" gridGap={8}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => history.push(routes.changesManagement.all)}
          >
            Voltar
          </Button>
          {!isFinalized && (
            <>
              <Button
                form="changes-management-form"
                type="submit"
                color="primary"
                variant="contained"
              >
                Salvar
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={() => setOpenFinalizeDialog(true)}
              >
                Finalizar
              </Button>
            </>
          )}
        </Box>
      </Container>
      <BaseDialog
        open={openFinalizeDialog}
        setOpen={setOpenFinalizeDialog}
        title="Finalizar Gestão de Mudança"
        closeButtonText="Cancelar"
        actionButtonText="Finalizar"
        dialogSize="sm"
        actionButton={handleFinalize}
        justifyActions="flex-end"
        fullWidth
      >
        <Box py={1}>
          <Typography variant="body1">
            Tem certeza que deseja finalizar esta gestão de mudança? Após
            finalizada, não será possível realizar edições.
          </Typography>
        </Box>
      </BaseDialog>
    </Page>
  )
}

export default ChangesManagementEdit
